import { render } from "./indexLotComponent.vue?vue&type=template&id=518687fe"
import script from "./indexLotComponent.vue?vue&type=script&lang=js"
export * from "./indexLotComponent.vue?vue&type=script&lang=js"

import "./indexLotComponent.vue?vue&type=style&index=0&id=518687fe&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__